export interface LoaderInterfaceState {
  visibility: number;
}

export const initialLoaderState: LoaderInterfaceState = {
  visibility: 0
};
